export const Moves: import('../../../sim/dex-moves').ModdedMoveDataTable = {
	dragonascent: {
		inherit: true,
		isNonstandard: "Future",
	},
	hyperspacefury: {
		inherit: true,
		isNonstandard: "Future",
	},
	originpulse: {
		inherit: true,
		isNonstandard: "Future",
	},
	precipiceblades: {
		inherit: true,
		isNonstandard: "Future",
	},
};
